import { useEffect, useState } from "react";
import { PropagateLoader } from "react-spinners";
import { useParams } from "react-router-dom";
import Heading from "../../atoms/Heading";
import CardHeader from "../../atoms/CardHeader";
import { GET_INMUEBLE_ID } from "../../../api/apiInmuebles";
import InmuebleAccesosDirectos from "../../organisms/inmueble/inmuebleDocsTables/InmuebleAccesosDirectos";
import { getInmobiliaria } from "../../../utils/getInmobiliaria";
import Breadcrumb from "../../molecules/Breadcrumb";

const InmuebleTemplate = () => {
    const { id, im } = useParams();
    const [loading, setLoading] = useState(true);
    const [inmueble, setInmueble] = useState();

    useEffect(() => {
        const getInmueble = async () => {
            try {
                const inmuebleData = await GET_INMUEBLE_ID(Number(im));
                setInmueble(inmuebleData);
            } catch (error) {
                console.error(error);
            } finally {
                setLoading(false);
            }
        };

        getInmueble();
    },[im]);

    if (loading) return <div className="w-full h-screen flex items-center justify-center"> <PropagateLoader color="red"/> </div>;

    return (
        <div className="flex flex-col gap-4">
            {inmueble ?
                    <>
                        <CardHeader
                          left={
                            <Breadcrumb
                              items={[
                                { label: "Inmobiliarias", to: "/inmobiliarias" },
                                { label: getInmobiliaria(id), to: `/inmobiliarias/${id}` },
                                { label: inmueble?.name, to: `/inmobiliarias/${id}/${im}` },
                              ]}
                            />
                          }
                        />
                        <InmuebleAccesosDirectos inmueble={inmueble} />
                    </>
                :
                    <Heading text="Error al obtener el inmueble intente mas tarde y/o contacte con soporte tecnico" />
            }
        </div>
    );
};

export default InmuebleTemplate;